import { render, staticRenderFns } from "./ServiceVar.vue?vue&type=template&id=001abb54&scoped=true&"
import script from "./ServiceVar.vue?vue&type=script&lang=js&"
export * from "./ServiceVar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001abb54",
  null
  
)

export default component.exports